'use strict';

/**
 * @name thirdApps
 */

exports.installed = require('./installed.js');



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/thirdApps/index.js
// module id = 392
// module chunks = 1 12 14